// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { License } from "./License";
import {
  LicenseFromJSON,
  LicenseFromJSONTyped,
  LicenseToJSON,
  LicenseToJSONTyped,
} from "./License";
import type { IdentityProvider } from "./IdentityProvider";
import {
  IdentityProviderFromJSON,
  IdentityProviderFromJSONTyped,
  IdentityProviderToJSON,
  IdentityProviderToJSONTyped,
} from "./IdentityProvider";

/**
 *
 * @export
 * @interface TenantRead
 */
export interface TenantRead {
  /**
   *
   */
  id: string;
  /**
   *
   */
  name: string;
  /**
   *
   */
  identityProviders: Array<IdentityProvider>;
  /**
   *
   */
  threediOrganisations: Array<string>;
  /**
   *
   */
  createdAt: Date;
  /**
   *
   */
  updatedAt: Date;
  /**
   *
   */
  description: string | null;
  /**
   *
   */
  license: License;
}

/**
 * Check if a given object implements the TenantRead interface.
 */
export function instanceOfTenantRead(value: object): value is TenantRead {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  if (
    (!("identityProviders" in (value as Record<string, any>)) &&
      !("identity_providers" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["identityProviders"] === undefined &&
      (value as Record<string, any>)["identity_providers"] === undefined)
  )
    return false;
  if (
    (!("threediOrganisations" in (value as Record<string, any>)) &&
      !("threedi_organisations" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["threediOrganisations"] === undefined &&
      (value as Record<string, any>)["threedi_organisations"] === undefined)
  )
    return false;
  if (
    (!("createdAt" in (value as Record<string, any>)) &&
      !("created_at" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["createdAt"] === undefined &&
      (value as Record<string, any>)["created_at"] === undefined)
  )
    return false;
  if (
    (!("updatedAt" in (value as Record<string, any>)) &&
      !("updated_at" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["updatedAt"] === undefined &&
      (value as Record<string, any>)["updated_at"] === undefined)
  )
    return false;
  if (!("description" in value) || value["description"] === undefined) return false;
  if (!("license" in value) || value["license"] === undefined) return false;
  return true;
}

export function TenantReadFromJSON(json: any): TenantRead {
  return TenantReadFromJSONTyped(json, false);
}

export function TenantReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantRead {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
    identityProviders: (json["identity_providers"] as Array<any>).map(IdentityProviderFromJSON),
    threediOrganisations: json["threedi_organisations"],
    createdAt: json["created_at"] == null ? json["created_at"] : parseDateTime(json["created_at"]),
    updatedAt: json["updated_at"] == null ? json["updated_at"] : parseDateTime(json["updated_at"]),
    description: json["description"],
    license: LicenseFromJSON(json["license"]),
  };
}

export function TenantReadToJSON(json: any): TenantRead {
  return TenantReadToJSONTyped(json, false);
}

export function TenantReadToJSONTyped(
  value?: TenantRead | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    name: value["name"],
    identity_providers: (value["identityProviders"] as Array<any>).map(IdentityProviderToJSON),
    threedi_organisations: value["threediOrganisations"],
    created_at:
      value["createdAt"] == null ? value["createdAt"] : serializeDateTime(value["createdAt"]),
    updated_at:
      value["updatedAt"] == null ? value["updatedAt"] : serializeDateTime(value["updatedAt"]),
    description: value["description"],
    license: LicenseToJSON(value["license"]),
  };
}
